export const sex = {
    both: 0,
    male: 1,
    female: 2,
};
export const numSexes = sex.female;

export const hAlign = {
    left: 0,
    right: 1,
    center: 2,
};

export const language = {
    english: 1,
    french: 2,
    arabic: 3,
    spanish: 4,
    russian: 5,
    portuguese: 6,
    chinese: 7,
    indonesian: 8,
};

export const menuItems = [
    "Undo",
    "Redo",
    "Cut",
    "copy",
    "Copy all",
    "paste",
    "Decrement decimal",
    "Increment decimal",
    "Duplicate across rows",
    "Duplicate down columns",
    "Interpolate",
    "Normalize",
    "Multiply",
    "Data source",
    "Show/Hide thousands separator",
    "Copy to JSON",
];

/* Screen size breakpoints from Bootstrap. */
export const smScreen = 768;
export const mdScreen = 850; // 992;
export const lgScreen = 1200;
